/* eslint-disable max-nested-callbacks */
/* eslint-disable no-promise-executor-return */
import { useEffect, useState } from 'react';
import { useMaybeRoomContext } from '@livekit/components-react';

interface ITestRoom {
  connected: boolean;
  setConnected: (connected: boolean) => void;
}

export const TestRoom = ({ connected, setConnected }: ITestRoom) => {
  const room = useMaybeRoomContext();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      if (!connected) {
        setCount(prev => prev + 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [connected]);

  useEffect(() => {
    if (room?.state === 'connected') {
      setConnected(true);
      setTimeout(() => room.disconnect(), 1000);
    }
  }, [room, count, room?.state, setConnected]);

  return null;
};
